export const color = {
  main: '#000',
  navigation: '#121212',
  navigationHovered: '#1c1c1c',
}
